import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link, NavLink, useLocation, useMatch, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import ImagesearchRollerIcon from "@mui/icons-material/ImagesearchRoller";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import {
  FaUserCircle,
  FaShoppingBag,
  FaFolder,
  FaChevronDown,
  FaTruckMoving,
  FaAngleDown,
} from "react-icons/fa";
import Typography from "@mui/material/Typography";
import { Divider, Collapse, Avatar, Popover } from "@mui/material";
import img from "./../../assets/img/spotkeep-logos.png";
const drawerWidth = 260;

function SideNav(props) {
  const navigate = useNavigate();
  const match = useMatch("/admin/user/*");
  const [openSubMenu, setOpenSubMenu] = useState({});


  const [activeTab, setActiveTab] = useState("");
const location=useLocation()
const tab = location.pathname
  const handleButtonClick = (buttonName) => {
    setOpenSubMenu((prevOpenSubMenu) => ({
      ...prevOpenSubMenu,
      [buttonName]: !prevOpenSubMenu[buttonName],
    }));
  };
  // useEffect(() => {
  //   navigate("/admin/campaigns");
  // }, []);

  useEffect(() => {
    const currentTab = listItemData.find(item => location.pathname.startsWith(item.link));
    if (currentTab) {
      setActiveTab(currentTab.label);
    }
  }, [location.pathname]);
  const listItemData = [
    { label: "Campaigns", icon: <DashboardIcon />, link: "/admin/campaigns" },
    { label: "Live campaigns", icon: <DashboardIcon />, link: "/admin/live-campaigns" },
    { label: "Jobs", icon: <ImagesearchRollerIcon />, link: "/admin/jobs" },
    { label: "Art Work", icon: <ViewCarouselIcon />, link: "/admin/arts" },
    {
      label: "Request",
      icon: <FaUserCircle size={23} />,
      link: "/admin/request",
    },
    {
      label: "Payments",
      icon: <CreditCardIcon size={23} />,
      link: "/admin/payments",
    },
    {
      label: "Vehicles",
      icon: <FaTruckMoving size={23} />,
      link: "/admin/vehicles",
    },
    {
      label: "Products",
      icon: <FaShoppingBag size={23} />,
      link: "/admin/product",
    },
    {
      label: "Team",
      icon: <FaUserCircle size={23} />,
      link: "/admin/users",
    },
    {
      label: "Account Types",
      icon: <FaFolder size={23} />,
      icon2: <FaAngleDown size={23} />,
      submenu: [
        {
          label: "Vendor",
          icon: <FaFolder size={23} />,
          link: "/admin/vendor",
          icon2: <FaAngleDown size={23} />,
          submenu: [
            { label: "driver ", link: "/admin/vendor/driver" },
            { label: "installer ", link: "/admin/vendor/installer" },
            { label: "photographer", link: "/admin/vendor/photographer" },
          ],
        },
        {
          label: "Advertiser",
          icon: <FaFolder size={23} />,
          link: "/admin/advertiser",
          icon2: <FaAngleDown size={23} />,
          submenu: [
            { label: "Company", link: "/admin/advertiser/corporation" },
            { label: "agency", link: "/admin/advertiser/advertiser" },
          ],
        },
      ],
    },
  ];
  const renderMenuItems = (items) => {
    return items.map((item, index) => {
      if (item.submenu) {
        return (
          <SubMenu
            style={{
              backgroundColor: activeTab === item.label && "#015A96",
              color: activeTab === item.label && "white",
            }}
            key={index}
            title={item.label}
            icon={item.icon}
            label={item.label}
            onClick={() => setActiveTab(item.label)}
          >
            {renderMenuItems(item.submenu)}
          </SubMenu>
        );
      } else {
        return (
          <MenuItem
            style={{
              backgroundColor: activeTab === item.label && "#015A96",
              color: activeTab === item.label && "white",
            }}
            onClick={() => setActiveTab(item.label)}
            key={index}
            icon={item.icon}
            component={<Link to={item.link} />}
          >
            {item.label}
          </MenuItem>
        );
      }
    });
  };

  return (
    <Box
      component="nav"
      sx={{
        width: { md: drawerWidth },
        flexShrink: { md: 0 },
        bgcolor: "#F4F4F4",
      }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        variant="temporary"
        open={props.mobileOpen}
        onClose={props.handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          bgcolor: "#F4F4F4",
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        <Sidebar style={{ marginTop: "80px" }}>
          <Menu iconShape="circle">{renderMenuItems(listItemData)}</Menu>
        </Sidebar>
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",

            width: drawerWidth,
          },
        }}
        open
      >
        <Sidebar style={{ marginTop: "80px" }}>
          <Menu iconShape="circle">{renderMenuItems(listItemData)}</Menu>
        </Sidebar>
      </Drawer>
    </Box>
  );
}

SideNav.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default SideNav;
